import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchHomepage } from "../api/marketingApi";
import { ListingCard } from "../components/ListingCard";

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.5 },
};

export function MarketingAbout() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchHomepage().then((d) => alive && setData(d));
    return () => {
      alive = false;
    };
  }, []);

  const about = data?.about;
  const portfolio = data?.portfolio || [];

  return (
    <>
      <section className="mx-auto max-w-[52rem] px-6 pt-12">
        <span className="font-sans text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-[#B7975A]">
          {about?.eyebrow || "About us"}
        </span>
        <h1 className="mb-4 mt-2 text-[clamp(2rem,5vw,3rem)] font-semibold tracking-tight">
          {about?.title || "Your dream property partner."}
        </h1>
        {about?.body_html ? (
          <div className="prose prose-lg max-w-none text-[#4A473E]" dangerouslySetInnerHTML={{ __html: about.body_html }} />
        ) : (
          <p className="text-[1.2rem] text-[#4A473E]">
            PropertyMakers helps families and businesses find the right property — homes to live in,
            spaces to grow in, and plots to build on.
          </p>
        )}

        {about?.highlights?.length > 0 && (
          <div className="mt-10 grid gap-6 [grid-template-columns:repeat(auto-fit,minmax(180px,1fr))]">
            {about.highlights.map((h, i) => (
              <div key={i}>
                <h3 className="m-0 text-[1.2rem] font-semibold">{h.title}</h3>
                <p className="mt-1 font-sans text-[0.92rem] text-[#4A473E]">{h.body}</p>
              </div>
            ))}
          </div>
        )}
      </section>

      <section id="work" className="mt-12 bg-[#EDEAE2]">
        <div className="mx-auto max-w-[74rem] px-6 py-16">
          <motion.div {...reveal}>
            <span className="font-sans text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-[#B7975A]">Previous work</span>
            <h2 className="mb-8 mt-1 text-[clamp(1.7rem,3.5vw,2.4rem)] font-semibold tracking-tight">
              Properties we've handed over
            </h2>
          </motion.div>
          {portfolio.length > 0 ? (
            <div className="grid gap-6 [grid-template-columns:repeat(auto-fill,minmax(280px,1fr))]">
              {portfolio.map((l) => (
                <ListingCard key={l.token} listing={l} />
              ))}
            </div>
          ) : (
            <div className="py-10 text-center font-sans text-[#78746A]">Our featured work will appear here soon.</div>
          )}
        </div>
      </section>

      <section className="mx-auto max-w-[40rem] px-6 py-16 text-center">
        <h2 className="text-[clamp(1.7rem,3.5vw,2.4rem)] font-semibold tracking-tight">Looking for something specific?</h2>
        <p className="mx-auto mb-6 mt-2 max-w-[36rem] text-[1.15rem] text-[#4A473E]">
          Browse the current book, or tell us what you need on any listing and we'll match it.
        </p>
        <Link to="/properties" className="inline-block rounded-[10px] bg-[#2C4A87] px-[1.3rem] py-[0.8rem] font-sans font-semibold text-white hover:bg-[#1F3766]">
          Browse properties
        </Link>
      </section>
    </>
  );
}
